
import AddIcon from "@mui/icons-material/Add";
import Delete from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Download } from "@mui/icons-material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { DeleteDialog } from "./DeleteDialog";
import {
  Backdrop,
  Modal,
  Snackbar,
  TextField,
  Typography,
  Box,
  Fab,
  Fade,
  Autocomplete,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  DialogTitle,
  Select,
  MenuItem,
  TablePagination,
  Switch
} from "@mui/material";

import formNames from "../config/formNames.json";

import MuiAlert from "@mui/material/Alert";
import DownloadConfirmDialog from "./DownloadConfirmDialog";
import { DataGrid, GridActionsCellItem, GridToolbar } from "@mui/x-data-grid";
import {
  collection,
  doc,
  onSnapshot,
  query,
  setDoc,
  getDocs,
  where,
  or,
  and
} from "firebase/firestore";
import React, { useEffect, useState, forwardRef, useRef } from "react";

import PDFViewer from "./PDFViewer";
import useCustomParams from "./shared/useCustomParams";
import FormDuplicateButton from "./FormDuplicateButton";
import axios from "axios";



const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export const Forms = (props) => {
  const {

    db,
    userId,
    groupId,
    isPro,
    allData,
    buildingId,    // ← add this
    projectId,
    applicantDetails,
    ownerDetails,
    filingRepDetails,
    buildingDetails,
    extraFieldsToAutoFill,
    isInactive,
    showToggleFromBuilding
    // showJobBuildingForms,
    // showLabelBuildingForms,
    // showLabelBuildingJobsForms
  } = props;

  const [fromBuildingShowFormsOfAssociatedJobs, setFromBuildingShowFormsOfAssociatedJobs] = useState(false)


  const [downloadFromForm, setDownloadFromForm] = useState(false)

  const [feedbackMessage, setFeedbackMessage] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingDownloadParams, setPendingDownloadParams] = useState(null);


  const [Forms, setForms] = useState([]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 2,
  };

  const [filteredForms, setFilteredForms] = useState([]);

  const [searchValue, setSearchValue] = useState("");

  const [isNewForm, setIsNewForm] = useState(false);

  const [newForm, setNewForm] = useState({
    fileName: "",
    formName: "",
    note: "",
  });

  const [editNote, setEditNote] = useState({
    note: "",
  });

  const openPDF = () => { };

  const copyApplication = (identifier) => {
    // write function to  copy application
    const thisForm = doc(props.db, "filings", identifier.row.formId);

    if (isInactive) {
      return;
    }

    const newForm = {
      ...identifier.row,
      dateCreated: Date.now(),
      dateUpdated: Date.now(),
    };
    delete newForm.id;
    props.db
      .collection("filings")
      .add({
        ...newForm,
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
  };

  const deleteApplication = (identifier) => {
    setItemToDelete({
      itemId: identifier.row.formId,
      identifier: identifier.row.formName,
    });
    setDeleteOpen(true);
  };

  const [currentNote, setCurrentNote] = useState();

  const editNoteApplication = (identifier) => {
    setCurrentNote(identifier.row.note);
    setItemToEdit({
      itemId: identifier.row.formId,
      identifier: identifier.row.formName,
    });
    seteditNoteOpen(true);
  };

  const confirmDelete = async () => {
    db.collection("filings").doc(itemToDelete.itemId).delete();
    setItemToDelete({ itemId: "", identifier: "" });
    setDeleteOpen(false);
    openFeedbackMessage('Form deleted successfully!', 'success');
    setForms((prevForms) =>
      prevForms.filter((form) => form.id !== itemToDelete.itemId)
    );

  };

  const [viewerOpen, setViewerOpen] = useState(false);

  const [newFormOpen, setNewFormOpen] = useState(false);
  const [editNoteOpen, seteditNoteOpen] = useState(false);

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [formToView, setFormToView] = useState({
    formId: "",
    formContent: "",
    formAnnotations: "",
    fileName: "",
  });

  const [deleteOpen, setDeleteOpen] = useState(false);


  const [hasAssociatedJobForms, setHasAssociatedJobForms] = useState(false);

  const [itemToDelete, setItemToDelete] = useState({
    itemId: "",
    identifier: "",
  });

  const [itemToEdit, setItemToEdit] = useState({
    itemId: "",
    identifier: "",
  });

  const [open, setOpen] = React.useState(false);

  const [loading, setLoading] = React.useState(false);






  const handleNewFormClose = () => {
    setNewFormOpen(false);
  };

  const handleEditNoteClose = () => {
    seteditNoteOpen(false);
  };

  const [failureOpen, setOpenFailure] = React.useState(false);

  const openSuccess = (message) => {
    setOpen(message || true);
  };

  const openFailure = () => {
    setOpenFailure(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleFailureClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenFailure(false);
  };

  const handleChangeNewForm = (values) => {
    setNewForm({
      ...newForm,
      fileName: values.filename,
      formName: values.label,
    });
  };

  const handleChangeNewFormNote = (event) => {
    setNewForm({ ...newForm, note: event.target.value });
  };

  const handleChangeEditNot = (event) => {
    setCurrentNote(event.target.value);
    setEditNote({ note: event.target.value });
  };

  useEffect(() => {
    const checkAssociatedJobForms = async () => {
      try {
        if (!props.buildingId) return;

        const projectsQuery = query(
          collection(db, "projects"),
          where("building", "==", props.buildingId)
        );
        const projectsSnapshot = await getDocs(projectsQuery);
        const projectIds = projectsSnapshot.docs.map((doc) => doc.id);

        if (projectIds.length === 0) return;

        const formsQuery = query(
          collection(db, "filings"),
          where("projectId", "in", projectIds)
        );
        const formsSnapshot = await getDocs(formsQuery);

        const associatedForms = formsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setHasAssociatedJobForms(associatedForms.length > 0);
      } catch (error) {
        console.error("Error checking associated job forms:", error);
      }
    };

    checkAssociatedJobForms();
  }, [props.buildingId]);


  useEffect(() => {
    const fetchForms = async () => {
      try {
        const baseCondition = (groupId && isPro && allData)
          ? or(
            where("userId", "==", userId),
            where("groupId", "==", groupId)
          )
          : where("userId", "==", userId);

        let finalQuery;

        if (fromBuildingShowFormsOfAssociatedJobs && buildingId) {
          const projSnap = await getDocs(
            query(
              collection(db, "projects"),
              where("building", "==", buildingId)
            )
          );
          const projectIds = projSnap.docs.map(d => d.id);

          finalQuery = query(
            collection(db, "filings"),
            or(
              and(
                baseCondition,
                where("projectId", "in", projectIds)
              ),
              where("buildingId", "==", buildingId)
            )
          );

        } else if (buildingId) {
          finalQuery = query(
            collection(db, "filings"),
            where("buildingId", "==", buildingId)
          );

        } else if (projectId) {
          finalQuery = query(
            collection(db, "filings"),
            baseCondition,
            where("projectId", "==", projectId)
          );

        } else {
          return;
        }

        const snap = await getDocs(finalQuery);
        setForms(snap.docs.map(doc => ({
          id: doc.id,
          flagged: doc.data().buildingId === "",
          ...doc.data()
        })));

      } catch (err) {
        console.error("Error fetching forms:", err);
      }
    };

    fetchForms();
  }, [
    fromBuildingShowFormsOfAssociatedJobs,
    buildingId,
    projectId,
    allData,
    groupId,
    isPro,
    userId,
    db
  ]);


  const columnDefs = isInactive
    ? [
      {
        field: "form",
        headerName: "Form type",
        flex: 2,
        headerClassName: "forms-header",
        ...(fromBuildingShowFormsOfAssociatedJobs
          ? {
            renderCell: (params) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: params.row.flagged ? "#002978" : "inherit",
                    fontWeight: params.row.flagged ? "bold" : "normal",

                  }}
                >
                  {params.value}
                </span>
              </div>
            ),
          }
          : {}),
      },

      {
        field: "dateCreated",
        headerName: "Date created",
        flex: 1,
        type: "date",
        valueFormatter: ({ value }) => {
          const d = new Date(value);
          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const yyyy = d.getFullYear();
          return `${dd}/${mm}/${yyyy}`;
        },
      },
      {
        field: "dateUpdated",
        headerName: "Date updated",
        flex: 1,
        type: "date",
        valueFormatter: ({ value }) => {
          const d = new Date(value);
          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const yyyy = d.getFullYear();
          return `${dd}/${mm}/${yyyy}`;
        },
      },
      {
        field: "note",
        headerName: "Note",
        flex: 4,
        headerClassName: "forms-header",
      },
    ]
    : [
      {
        field: "form",
        headerName: "Form type",
        flex: 2,
        headerClassName: "forms-header",
        ...(fromBuildingShowFormsOfAssociatedJobs
          ? {
            renderCell: (params) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    color: params.row.flagged ? "#002978" : "inherit",
                    fontWeight: params.row.flagged ? "bold" : "normal",

                  }}
                >
                  {params.value}
                </span>
              </div>
            ),
          }
          : {}),
      },

      {
        field: "dateCreated",
        headerName: "Date created",
        flex: 1,
        headerClassName: "forms-header",
        sortable: true,
        renderCell: ({ value }) => {
          const d = new Date(value);
          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const yyyy = d.getFullYear();
          return `${dd}/${mm}/${yyyy}`;
        },
      },
      {
        field: "dateUpdated",
        headerName: "Date updated",
        flex: 1,
        headerClassName: "forms-header",
        sortable: true,
        renderCell: ({ value }) => {
          const d = new Date(value);
          const dd = String(d.getDate()).padStart(2, "0");
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const yyyy = d.getFullYear();
          return `${dd}/${mm}/${yyyy}`;
        },
      },
      {
        field: "note",
        headerName: "Note",
        flex: 4,
        headerClassName: "forms-header",
      },
      {
        field: "actions",
        type: "actions",
        headerClassName: "forms-header",

        getActions: (params) => {
          const actions = [];

          actions.push(
            <GridActionsCellItem
              icon={<Download />}
              onClick={(e) => {
                setDownloadFromForm(true);
                handleOpenForm(params);
              }}
              label="Download"
            />
          );

          actions.push(
            <GridActionsCellItem
              icon={<EditIcon />}
              onClick={() => editNoteApplication(params)}
              label="Edit Note"
            />
          );

          if (!fromBuildingShowFormsOfAssociatedJobs) {


            actions.push(
              <FormDuplicateButton
                formDetails={params}
                collection={props?.buildingId ? "buildings" : "projects"}
                forms={Forms}
                openSucess={openSuccess}
                setForms={setForms}
                fromFormsOfBuilding={true}
              />
            );

          }
          actions.push(
            <GridActionsCellItem
              icon={<Delete />}
              onClick={() => deleteApplication(params)}
              label="Delete"
            />
          );


          return actions;
        },
        flex: 1,

      },
    ];

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString();
  };

  const handleNewForm = () => {
    setNewForm({
      fileName: "",
      formName: "",
      note: "",
    });
    setNewFormOpen(true);
  };

  const handleCopyForm = () => {
    setNewFormOpen(true);
  };

  const handleSave = (formContent, annotations, formId) => {
    const thisForm = doc(props.db, "filings", formId);
    const now = Date.now();

    setDoc(thisForm, {
      annotations: JSON.stringify(annotations),
      content: JSON.stringify(formContent),
      dateUpdated: now,
      needsAutoFill: false,   
    }, { merge: true })
      .then(() => {
        openSuccess();
        setLoading(false);
        setFormToView(prev => ({
          ...prev,
          formContent: formContent,
          formAnnotations: annotations,
        }));
        setForms(list =>
          list.map(f =>
            f.id === formId
              ? {
                ...f,
                content: JSON.stringify(formContent),
                annotations: JSON.stringify(annotations),
                dateUpdated: now,
              }
              : f
          )
        );
      })
      .catch(() => {
        openFailure();
        setLoading(false);
      });
  };



  const handleOpenForm = (event) => {
    console.log("Opening form, content type:", typeof event.row.content);
    console.log("Raw content:", event.row.content);

    setFormToView({
      formId: event.row.formId,
      formContent: event.row.content,
      formAnnotations: event.row.annotations,
      fileName: event.row.fileName,
    });
    setIsNewForm(!!event.row.needsAutoFill);
    setViewerOpen(true);
  };

  const handleCloseViewer = () => {
    setViewerOpen(false);
  };

  const handleAddForm = () => {
    db.collection("filings")
      .add({
        ...newForm,
        form: newForm.formName,
        userId: userId,
        groupId: groupId,
        buildingId: props.buildingId ? props.buildingId : "",
        projectId: props.projectId ? props.projectId : "",
        dateCreated: Date.now(),
        dateUpdated: Date.now(),
      })
      .then((docRef) => {

        const addedForm = {
          id: docRef.id,
          form: newForm.formName,
          userId: userId,
          groupId: groupId,
          buildingId: props.buildingId ? props.buildingId : "",
          projectId: props.projectId ? props.projectId : "",
          dateCreated: Date.now(),
          dateUpdated: Date.now(),
          fileName: newForm.fileName,
          note: newForm.note,
        };
        setForms((prevForms) => [...prevForms, addedForm]);


        setFormToView({
          formId: docRef.id,
          formContent: "",
          formAnnotations: "",
          fileName: newForm.fileName,
          note: newForm.note,
        });

        setViewerOpen(true);
        setNewFormOpen(false);
        setIsNewForm(true);

        openFeedbackMessage('Form added successfully!', 'success');
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
  };

  const handleEditNote = (item) => {
    db.collection("filings")
      .doc(item.itemId) // Get the specific document by its ID
      .update({
        note: editNote.note,
      })
      .then(() => {
        setForms((prevForms) =>
          prevForms.map((form) =>
            form.id === item.itemId ? { ...form, note: editNote.note } : form
          )
        );

        console.log("Note successfully updated!");
        // Optionally, you can add logic here to reflect the change in your UI
        seteditNoteOpen(false);
        setFormToView((prev) => ({
          ...prev,
          note: editNote.note,
        }));
        openFeedbackMessage('Form updated successfully!', 'success');
      })

      .catch((error) => {
        console.error("Error updating document: ", error);
      });
  };


  const openFeedbackMessage = (message, severity) => {
    setFeedbackMessage({ open: true, message, severity });
  };

  const handleCloseFeedbackMessage = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setFeedbackMessage({ ...feedbackMessage, open: false });
  };


  const handleFlagged = () => {
    setFromBuildingShowFormsOfAssociatedJobs((prev) => !prev)
  }





  const parsedForms = Forms.map((application, index) => ({
    ...application,
    dateCreated: new Date(application.dateCreated),
    dateUpdated: new Date(application.dateUpdated),
    id: index,
    formId: application.id,
  }));

  const autoFillDetails = [
    { prefix: "app", details: applicantDetails },
    { prefix: "owner", details: ownerDetails },
    { prefix: "frep", details: filingRepDetails },
    { prefix: "", details: buildingDetails },
    { prefix: "", details: extraFieldsToAutoFill }
  ];



  // const [paginationModel, setPaginationModel] = useState({
  //   pageSize: 50,
  //   page: 0,
  // });

  const { params, updateParams } = useCustomParams();

  const pageSize = Number(params.get("pageSize")) || 50,
    page = Number(params.get("page")) || 0;



  return (
    <>
      {(parsedForms.length > 0 || hasAssociatedJobForms) && !viewerOpen || downloadFromForm && parsedForms.length > 0 ? (
        <div
          style={{
            height: "calc(100vh - 240px)",
            width: "100%",
          }}
        >
          {(Forms.length > 0 || hasAssociatedJobForms) && showToggleFromBuilding && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                marginBottom: "20px"
              }}
            >
              <Typography align="left" variant="h4" sx={{ marginRight: "20px" }}>
                FORMS
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  backgroundColor: "#e9e9e9",
                  borderRadius: "4px",
                  padding: "5px 17px",
                }}
              >
                <Typography variant="body1">Forms of Associated Jobs</Typography>
                <Switch
                  checked={fromBuildingShowFormsOfAssociatedJobs}
                  onChange={handleFlagged}
                  color="primary"
                  size="medium"
                />
              </Box>
            </Box>
          )}


          <div
            style={{
              display: "flex",
              height: "100%",
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <DataGrid
                rows={parsedForms}
                columns={columnDefs}
                rowCount={parsedForms.length}
                onRowClick={(e) => {
                  handleOpenForm(e);
                }}
                pagination
                hideFooter
                pageSizeOptions={[10, 25, 50, 100]}
                onPaginationModelChange={(params) => {
                  updateParams({
                    page: params.page,
                    pageSize: params.pageSize,
                  });
                }}
                paginationModel={{ pageSize, page }}
                initialState={{
                  pagination: { paginationModel: { pageSize: 50 } },
                }}
                onFilterModelChange={(e) => {
                  updateParams({
                    pageSize: false,
                    page: false,
                    search: e?.items?.map((item) => item?.value).join(""),
                  });
                }}
                slots={{
                  toolbar: GridToolbar,
                }}
              ></DataGrid>
              {Forms.length > 0 && (
                <TablePagination
                  component="div"
                  count={Forms.length}
                  page={page}
                  onPageChange={(_, e) => {
                    updateParams({
                      page: e,
                      pageIncreasing: `${e > Number(params.get("page"))}`,
                    });
                  }}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  rowsPerPage={pageSize}
                  onRowsPerPageChange={(e) => {
                    updateParams({
                      pageSize: `${e.target.value}`,
                      page: false,
                    });
                  }}
                />
              )}
            </div>
          </div>
        </div>
      ) : null}
      <Box
        sx={{
          position: "fixed",
          bottom: "1rem",
          left: "4rem",
          "& > :not(style)": { m: 1 },
        }}
      >
        {!viewerOpen && !isInactive && (
          <Fab
            color="primary"
            aria-label="add"
            variant="extended"
            onClick={handleNewForm}
            disabled={props.isInactive}
          >
            <AddIcon sx={{ mr: 1 }} />
            New
          </Fab>
        )}
      </Box>
      {viewerOpen && (
        <PDFViewer
          handleSave={handleSave}
          handleCloseViewer={handleCloseViewer}
          formToView={formToView}
          setLoading={setLoading}
          isNewForm={isNewForm}
          autoFillDetails={autoFillDetails}
          isInactive={isInactive}
          downloadFromForm={downloadFromForm}
          setDownloadFromForm={setDownloadFromForm}
        />
      )}
      <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {open?.length > 0 ? open : "Form saved successfully!"}
        </Alert>
      </Snackbar>
      <Snackbar
        open={failureOpen}
        autoHideDuration={2000}
        onClose={handleFailureClose}
      >
        <Alert
          onClose={handleFailureClose}
          severity="error"
          sx={{ width: "100%" }}
        >
          Something went wrong!
        </Alert>
      </Snackbar>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={loading}
        onClose={handleCloseLoading}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={loading}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              Preparing PDF
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              Preparing PDF file...
            </Typography>
          </Box>
        </Fade>
      </Modal>

      <Dialog
        open={newFormOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"lg"}
      >
        <DialogTitle id="alert-dialog-title">Add Form</DialogTitle>
        <DialogContent>
          <Autocomplete
            options={formNames}
            label="Form"
            fullWidth
            groupBy={(option) => option.agency}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => <TextField {...params} label="Form" />}
            sx={{ mb: 2, mt: 1, minWidth: "400px" }}
            onChange={(event, newValue) => {
              handleChangeNewForm(newValue);
            }}
          />

          <TextField
            label={"Note"}
            name="note"
            multiline
            minRows={4}
            value={newForm.note}
            onChange={(event) => {
              handleChangeNewFormNote(event);
            }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleAddForm}>
            Add
          </Button>
          <Button
            onClick={handleNewFormClose}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={editNoteOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={"lg"}
      >
        <DialogTitle id="alert-dialog-title">Edit Note</DialogTitle>
        <DialogContent>
          <TextField
            label={"Note"}
            name="note"
            value={currentNote}
            multiline
            minRows={4}
            sx={{ my: 2 }}
            onChange={(event) => {
              handleChangeEditNot(event);
            }}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => handleEditNote(itemToEdit)}
          >
            Edit Note
          </Button>
          <Button
            onClick={handleEditNoteClose}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <DeleteDialog
        open={deleteOpen}
        confirmDelete={confirmDelete}
        setDialogOpen={setDeleteOpen}
        identifier={itemToDelete.identifier}
      />
      <Snackbar
        open={feedbackMessage.open}
        autoHideDuration={2000}
        onClose={handleCloseFeedbackMessage}
      >
        <Alert
          onClose={handleCloseFeedbackMessage}
          severity={feedbackMessage.severity}
          sx={{ width: "100%" }}
        >
          {feedbackMessage.message}
        </Alert>
      </Snackbar>
    </>
  );
};

